{
	"toastLoginFailed": "Login failed. Please try again.",
	"toastSessionExpired": "Your session has expired. Please log in again."
}
